import { render } from "./ipw_I.vue?vue&type=template&id=aa000956"
import script from "./ipw_I.vue?vue&type=script&lang=js"
export * from "./ipw_I.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__